{
  "title": "Remote Access (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "1st-level transmutation (technomagic)",
  "level": 1,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "10 minutes",
  "description": [
    "You can use any electronic device within range as if it were in your hands. This is not a telekinesis effect. Rather, this spell allows you to simulate a device's mechanical functions electronically. You are able to access only functions that a person using the device manually would be able to access. You can use remote access with only one device at a time."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
